/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPasswordReset.defs'
export { main as default } from './requestPasswordReset.defs'
